import React, { ReactElement } from "react"
import { useECommerceMachine } from "../../app-core/_common/machines/machines-context"
import { isPresent } from "../../app-core/_common/checks"
import styles from "./PageTitle.module.scss"

type Props = {
    titleHead: string | ReactElement
    dataContentName: string
    showFlowTitle?: boolean
}

const PageTitle: React.FC<React.PropsWithChildren<Props>> = ({
    children,
    titleHead,
    dataContentName,
    showFlowTitle = false,
}) => {
    const [state] = useECommerceMachine()
    const flowTitle = showFlowTitle ? state.context.flowVersion.ui.pageFlowTitle() : undefined

    return (
        <div data-content-name={dataContentName} className={styles.container}>
            {isPresent(flowTitle) && <div className={styles.flowTitle}>{flowTitle}</div>}
            <h2 data-test-id="section-title" className={styles.title}>
                {titleHead}
            </h2>
            {children && <div className={styles.body}>{children}</div>}
        </div>
    )
}

export default PageTitle
